/* tslint:disable */
/* eslint-disable */
/**
 * Example API
 * API description
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { Country } from './Country';
import {
    CountryFromJSON,
    CountryFromJSONTyped,
    CountryToJSON,
    CountryToJSONTyped,
} from './Country';
import type { Image } from './Image';
import {
    ImageFromJSON,
    ImageFromJSONTyped,
    ImageToJSON,
    ImageToJSONTyped,
} from './Image';
import type { Place } from './Place';
import {
    PlaceFromJSON,
    PlaceFromJSONTyped,
    PlaceToJSON,
    PlaceToJSONTyped,
} from './Place';

/**
 * 
 * @export
 * @interface Stop
 */
export interface Stop {
    /**
     * Unique identifier for the stop
     * @type {string}
     * @memberof Stop
     */
    readonly id: string;
    /**
     * Order index of the stop in the itinerary
     * @type {number}
     * @memberof Stop
     */
    index: number;
    /**
     * Title of the stop
     * @type {string}
     * @memberof Stop
     */
    title: string;
    /**
     * URL of the stop image
     * @type {string}
     * @memberof Stop
     */
    imageUrl?: string;
    /**
     * Image entity with attribution details
     * @type {Image}
     * @memberof Stop
     */
    readonly image?: Image;
    /**
     * ID of the associated image entity
     * @type {string}
     * @memberof Stop
     */
    readonly imageId?: string;
    /**
     * Highlight of the stop
     * @type {string}
     * @memberof Stop
     */
    highlight?: string;
    /**
     * Detailed description of the stop
     * @type {string}
     * @memberof Stop
     */
    description?: string;
    /**
     * Start time for this stop in HH:MM format
     * @type {string}
     * @memberof Stop
     */
    startTime?: string;
    /**
     * Duration of the stop in minutes
     * @type {number}
     * @memberof Stop
     */
    durationMinutes?: number;
    /**
     * State of the stop (suggested by AI, accepted by user, or rejected)
     * @type {string}
     * @memberof Stop
     */
    state: StopStateEnum;
    /**
     * Origin of the stop (created by AI or manually)
     * @type {string}
     * @memberof Stop
     */
    origin: StopOriginEnum;
    /**
     * Timestamp when the stop was created
     * @type {Date}
     * @memberof Stop
     */
    readonly createdAt: Date;
    /**
     * Timestamp when the stop was last updated
     * @type {Date}
     * @memberof Stop
     */
    readonly updatedAt: Date;
    /**
     * ID of the parent itinerary
     * @type {string}
     * @memberof Stop
     */
    readonly itineraryId: string;
    /**
     * Country where this stop is located
     * @type {Country}
     * @memberof Stop
     */
    readonly country: Country;
    /**
     * ID of the country where this stop is located
     * @type {string}
     * @memberof Stop
     */
    readonly countryId: string;
    /**
     * Country code where this stop is located
     * @type {string}
     * @memberof Stop
     */
    readonly countryCode: string;
    /**
     * Place associated with this stop
     * @type {Place}
     * @memberof Stop
     */
    readonly place: Place;
    /**
     * ID of the place associated with this stop
     * @type {string}
     * @memberof Stop
     */
    readonly placeId: string;
    /**
     * IDs of days this stop belongs to
     * @type {Array<string>}
     * @memberof Stop
     */
    dayIds: Array<string>;
    /**
     * Number of days this stop belongs to
     * @type {number}
     * @memberof Stop
     */
    daysCount: number;
    /**
     * City name for location-based searches
     * @type {string}
     * @memberof Stop
     */
    addressCity: string;
    /**
     * Country name for location-based searches
     * @type {string}
     * @memberof Stop
     */
    addressCountry: string;
    /**
     * Full address line for location searches
     * @type {string}
     * @memberof Stop
     */
    addressLine: string;
    /**
     * State or province for location searches
     * @type {string}
     * @memberof Stop
     */
    addressState: string;
    /**
     * Place name for location searches
     * @type {string}
     * @memberof Stop
     */
    placeName: string;
    /**
     * Full place name with hierarchy
     * @type {string}
     * @memberof Stop
     */
    placeFullName: string;
    /**
     * Geographic coordinates of the stop (from associated place)
     * @type {object}
     * @memberof Stop
     */
    readonly coordinates: object;
    /**
     * Address of the stop (from associated place)
     * @type {object}
     * @memberof Stop
     */
    readonly address: object;
}


/**
 * @export
 */
export const StopStateEnum = {
    Suggested: 'SUGGESTED',
    Accepted: 'ACCEPTED',
    Rejected: 'REJECTED'
} as const;
export type StopStateEnum = typeof StopStateEnum[keyof typeof StopStateEnum];

/**
 * @export
 */
export const StopOriginEnum = {
    Ai: 'AI',
    Manual: 'MANUAL'
} as const;
export type StopOriginEnum = typeof StopOriginEnum[keyof typeof StopOriginEnum];


/**
 * Check if a given object implements the Stop interface.
 */
export function instanceOfStop(value: object): value is Stop {
    if (!('id' in value) || value['id'] === undefined) return false;
    if (!('index' in value) || value['index'] === undefined) return false;
    if (!('title' in value) || value['title'] === undefined) return false;
    if (!('state' in value) || value['state'] === undefined) return false;
    if (!('origin' in value) || value['origin'] === undefined) return false;
    if (!('createdAt' in value) || value['createdAt'] === undefined) return false;
    if (!('updatedAt' in value) || value['updatedAt'] === undefined) return false;
    if (!('itineraryId' in value) || value['itineraryId'] === undefined) return false;
    if (!('country' in value) || value['country'] === undefined) return false;
    if (!('countryId' in value) || value['countryId'] === undefined) return false;
    if (!('countryCode' in value) || value['countryCode'] === undefined) return false;
    if (!('place' in value) || value['place'] === undefined) return false;
    if (!('placeId' in value) || value['placeId'] === undefined) return false;
    if (!('dayIds' in value) || value['dayIds'] === undefined) return false;
    if (!('daysCount' in value) || value['daysCount'] === undefined) return false;
    if (!('addressCity' in value) || value['addressCity'] === undefined) return false;
    if (!('addressCountry' in value) || value['addressCountry'] === undefined) return false;
    if (!('addressLine' in value) || value['addressLine'] === undefined) return false;
    if (!('addressState' in value) || value['addressState'] === undefined) return false;
    if (!('placeName' in value) || value['placeName'] === undefined) return false;
    if (!('placeFullName' in value) || value['placeFullName'] === undefined) return false;
    if (!('coordinates' in value) || value['coordinates'] === undefined) return false;
    if (!('address' in value) || value['address'] === undefined) return false;
    return true;
}

export function StopFromJSON(json: any): Stop {
    return StopFromJSONTyped(json, false);
}

export function StopFromJSONTyped(json: any, ignoreDiscriminator: boolean): Stop {
    if (json == null) {
        return json;
    }
    return {
        
        'id': json['id'],
        'index': json['index'],
        'title': json['title'],
        'imageUrl': json['imageUrl'] == null ? undefined : json['imageUrl'],
        'image': json['image'] == null ? undefined : ImageFromJSON(json['image']),
        'imageId': json['imageId'] == null ? undefined : json['imageId'],
        'highlight': json['highlight'] == null ? undefined : json['highlight'],
        'description': json['description'] == null ? undefined : json['description'],
        'startTime': json['startTime'] == null ? undefined : json['startTime'],
        'durationMinutes': json['durationMinutes'] == null ? undefined : json['durationMinutes'],
        'state': json['state'],
        'origin': json['origin'],
        'createdAt': (new Date(json['createdAt'])),
        'updatedAt': (new Date(json['updatedAt'])),
        'itineraryId': json['itineraryId'],
        'country': CountryFromJSON(json['country']),
        'countryId': json['countryId'],
        'countryCode': json['countryCode'],
        'place': PlaceFromJSON(json['place']),
        'placeId': json['placeId'],
        'dayIds': json['dayIds'],
        'daysCount': json['daysCount'],
        'addressCity': json['addressCity'],
        'addressCountry': json['addressCountry'],
        'addressLine': json['addressLine'],
        'addressState': json['addressState'],
        'placeName': json['placeName'],
        'placeFullName': json['placeFullName'],
        'coordinates': json['coordinates'],
        'address': json['address'],
    };
}

  export function StopToJSON(json: any): Stop {
      return StopToJSONTyped(json, false);
  }

  export function StopToJSONTyped(value?: Omit<Stop, 'id'|'image'|'imageId'|'createdAt'|'updatedAt'|'itineraryId'|'country'|'countryId'|'countryCode'|'place'|'placeId'|'coordinates'|'address'> | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'index': value['index'],
        'title': value['title'],
        'imageUrl': value['imageUrl'],
        'highlight': value['highlight'],
        'description': value['description'],
        'startTime': value['startTime'],
        'durationMinutes': value['durationMinutes'],
        'state': value['state'],
        'origin': value['origin'],
        'dayIds': value['dayIds'],
        'daysCount': value['daysCount'],
        'addressCity': value['addressCity'],
        'addressCountry': value['addressCountry'],
        'addressLine': value['addressLine'],
        'addressState': value['addressState'],
        'placeName': value['placeName'],
        'placeFullName': value['placeFullName'],
    };
}

